










































import Vue, { PropType } from 'vue';
import { DropdownList, PaginationData } from '@/types';
import { Column, ColumnType } from '@/components/table/types';
import ColumnsTable from '@/components/table/ColumnsTable.vue';
import FieldSelect from '@/components/form/FieldSelect.vue';

export default Vue.extend({
  name: 'Panel',
  components: {
    ColumnsTable,
    FieldSelect,
  },

  props: {
    paginationData: {
      type: Object as PropType<PaginationData>,
    },
    perPageList: {
      type: Array as PropType<Array<DropdownList>>,
      default: () => [
        { label: '20', value: 20 },
        { label: '50', value: 50 },
        { label: '100', value: 100 },
      ],
    },
    columns: {
      type: Array as PropType<Array<Column>>,
      default: () => [],
    },
    totalIsOpen: {
      type: Boolean,
    },
    totalActive: {
      type: Boolean,
      default: false,
    },
    isCheckboxAction: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    filteredColumns(): Array<Column> {
      return this.columns.filter((columns: Column) => {
        return columns.type !== ColumnType.TYPE_ACTIONS;
      });
    },
  },

  methods: {
    changePerPage(data) {
      this.$emit('changePerPage', data);
    },
    changeColumn(data) {
      this.$emit('changeColumn', data);
    },
    changeTotal() {
      this.$emit('changeTotal');
    },
  },
});
